import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BellRing, ArrowRight, CheckCircle2 } from 'lucide-react';
import { renewalsApi } from '../../lib/api';

const stageColors = {
  '60': 'bg-emerald-100 text-emerald-700 border-emerald-200',
  '30': 'bg-blue-100 text-blue-700 border-blue-200',
  '14': 'bg-amber-100 text-amber-700 border-amber-200',
  '7':  'bg-rose-100 text-rose-700 border-rose-200',
  'overdue': 'bg-rose-200 text-rose-800 border-rose-300',
};

const stageLabel = {
  '60': '60 days',
  '30': '30 days',
  '14': '14 days',
  '7': '7 days',
  'overdue': 'Overdue',
};

export default function Renewals() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    renewalsApi.list().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-6">
        <span className="eyebrow">Renewals</span>
        <h1 className="mt-2 text-3xl font-bold text-[#0b1f3a]">Renewal reminders</h1>
        <p className="text-slate-600 text-sm mt-1">Automatic reminders at 60, 30, 14 and 7 days before your policy renews.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {['60','30','14','7'].map((s) => (
          <div key={s} className={`rounded-xl border p-4 ${stageColors[s]}`}>
            <p className="text-xs uppercase font-semibold tracking-wider">{s} day reminder</p>
            <p className="text-2xl font-bold mt-1">{items.filter((i) => i.stage === s).length}</p>
          </div>
        ))}
      </div>

      {loading ? (
        <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
      ) : items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center">
          <CheckCircle2 size={32} className="mx-auto text-emerald-500" />
          <p className="mt-3 text-slate-700 font-semibold">All clear</p>
          <p className="text-slate-500 text-sm mt-1">No upcoming renewals in the next 60 days.</p>
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-2xl divide-y divide-slate-100">
          {items.map((r) => (
            <div key={r.id} className="p-5 flex flex-col md:flex-row md:items-center gap-4">
              <span className="icon-tile"><BellRing size={18} /></span>
              <div className="flex-1">
                <p className="font-semibold text-[#0b1f3a]">{r.insurer} · {r.type === 'health' ? 'Health' : 'Home'} insurance</p>
                <p className="text-xs text-slate-500 mt-0.5">Renews {r.renewal_date}</p>
              </div>
              <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${stageColors[r.stage]}`}>
                {r.days_until >= 0 ? `${r.days_until} days` : 'Overdue'} · {stageLabel[r.stage]}
              </span>
              <Link to="/home-insurance" className="btn-primary !py-2">
                Compare again <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
